import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Navigation from 'blocks/Navigation';
import { inject } from 'mobx-react';
import styled from 'styled-components';
import ForInvestorsItem from './ForInvestorsItem/ForInvestorsItem'
import get from 'lodash/get';
import { defaultFont, headersFont } from './consts/index'


const PageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Container = styled.div`
  min-height: 300px;
  padding-top: 70px;
  padding-bottom: 40px;
  width: 1366px;
  display: flex;
  flex-direction: column;
  justify-content: center;


`;

const Header = styled.h2`
  font-size: 50px;
  text-align: center;
  font-family: ${headersFont};
  font-weight: 700;`;

const Description = styled.div`
  font-family: ${defaultFont};
  font-size: 30px;
  text-align: center;
`;
const SectionName = styled.h3`
  font-family: ${headersFont};
  font-weight: 700;
  font-size: 30px;
`



@inject('forInvestorsStore', 'appStore')

export default class ForInvestors extends Component {

  async componentDidMount() {
    const { forInvestorsStore } = this.props;

    root.scrollTo(0, 0);

    await forInvestorsStore.getForInvestorsData();

    const {
      forInvestorsStore: {
        fetchedInvestorData
      },
    } = this.props;


    const { sectionHeader, sectionDescription, sectionsData } = fetchedInvestorData

    this.setState({
      header: sectionHeader,
      description: sectionDescription,
      sectionsData: [...sectionsData]
    })
  }
  render() {
    const {
      appStore: { currentUrl },
    } = this.props;

    return (
      <Fragment>
        <Helmet>
          <link rel="canonical" href={currentUrl} />
        </Helmet>
        <Navigation />
        <PageContainer>
          <Container>
            {this.state && this.state.header && <Header>{this.state.header}</Header>}
            {this.state && this.state.description && <Description>{this.state.description}</Description>}
            {this.state && this.state.sectionsData && this.state.sectionsData.map(({ sectionName, linkedFiles }) => sectionName && <div>
              {sectionName && <SectionName>{sectionName}</SectionName>}
              {/* I need to do here lodash get instead of Kentico model because the triple nested model is for somehow breaking the application*/}
              {linkedFiles && linkedFiles.map(item => <ForInvestorsItem icon={get(item, 'file_type.value[0].codename', '')} description={get(item, 'description.value', '')} date={get(item, 'date.value', '')} url={get(item, 'linked_asset.value[0].url', '')} />)}
            </div>)}
          </Container>
        </PageContainer>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ForInvestors/index.jsx